"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
function resolverBottomRight(_a) {
    var trigger = _a.trigger, content = _a.content;
    var left = trigger.rightBottomAnchor.x - content.width;
    var top = trigger.rightBottomAnchor.y - content.height;
    if (left > 0 && top > 0) {
        return {
            left: left,
            top: top,
        };
    }
    return false;
}
exports.default = resolverBottomRight;
//# sourceMappingURL=resolverBottomRight.js.map